import { webservices } from "../utils/constants";
import { httpPostFetch, httpGetFetch, httpGetFetchForIfsc, httpGetFetchForPincode } from "../utils/util";
export const getValidateNo = (mobilenum) => {
    return httpGetFetch(webservices.getValidateNo + mobilenum)
}
export const getAppStatus = () => {
    return httpGetFetch(webservices.getAppStatus)
}
export const saveUserLogin = (details) => {
    return httpPostFetch(webservices.saveUserLogin, details)
}
export const saveUserUsage = (details) => {
    return httpPostFetch(webservices.saveUserUsage, details)
}
export const getOtp = (mobilenum) => {
    return httpGetFetch(webservices.getOtp + mobilenum)
}
export const getState = (details) => {
    return httpPostFetch(webservices.getState, details)
}
export const getCity = (details) => {
    return httpPostFetch(webservices.getCity, details)
}
export const getTransactinType = (details, token) => {
    return httpPostFetch(webservices.getTransactionType, details, token)
}
export const getUserDetail = (mobilenum, couponCode, token) => {
    return httpGetFetch(webservices.getUserDetail + mobilenum + '/' + couponCode, token)
}
export const getTransactionHistory = (mobilenum, type, token) => {
    return httpGetFetch(webservices.getTransactionHistory + mobilenum + '/' + type, token)
}
export const saveUserData = (details, token) => {
    return httpPostFetch(webservices.saveUserData, details, token)
}
export const validateOtp = (details) => {
    return httpPostFetch(webservices.validateOtp, details)
}
export const getPaymentMode = (details, token) => {
    return httpPostFetch(webservices.getPaymentMode, details, token)
}
export const saveBankData = (details, token) => {
    return httpPostFetch(webservices.saveBankData, details, token)
}
export const saveMobileNo = (details) => {
    return httpPostFetch(webservices.saveMobileNo, details)
}
export const deleteBankUpi = (details, token) => {
    return httpPostFetch(webservices.deleteBankUpi, details, token)
}
export const scanCouponRegister = (details) => {
    return httpPostFetch(webservices.scanCouponRegister, details)
}
export const getUserType = (details) => {
    return httpPostFetch(webservices.getUserType, details)
}
export const getTermsConditions = (mobilenum, token) => {
    return httpGetFetch(webservices.getTermsConditions + mobilenum, token)
}
export const getIfscDetails = (ifsc) => {
    return httpGetFetchForIfsc(ifsc)
}
export const getStateCity = (details, token) => {
    return httpPostFetch(webservices.geoLocation, details, token)
}
export const getPincodeCheck = (pincode) => {
    return httpGetFetchForPincode(pincode)
}
export const checkRedeemValue = (details, token) => {
    return httpPostFetch(webservices.chkRedeemCouponAllow, details, token)
}
export const saveBankTransaction = (details, token) => {
    return httpPostFetch(webservices.saveBankTransaction, details, token)
}
export const upiVerify = (details, token) => {
    return httpPostFetch(webservices.upiVerify, details, token)
}
export const bankVerify = (details, token) => {
    return httpPostFetch(webservices.bankVerify, details, token)
}
export const saveUpiTransaction = (details, token) => {
    return httpPostFetch(webservices.saveUpiTransaction, details, token)
}

